module.exports = __webpack_public_path__ + "media/images/cards/american_express-b3abb55dbf7725b2e3a010d755feb59a.png";